import { createSlice } from '@reduxjs/toolkit'

export const viewSlice = createSlice({
  name: "view",
  initialState: {
    view: 'category',
    load: false,
    title: '',
    itemName: ''
  },
  reducers: {
    back: (state, action) => {
      return {
        ...state,
        view: action.payload
      }
    },
    items: (state, action) => {
      return {
        ...state,
        view: 'categoryItem',
        title: action.payload
      }
    },
    itemView: (state, action) => {
      return {
        ...state,
        view: 'itemOptions',
        itemName: action.payload
      }
    },
    updateTitle: (state, action) => {
      return {
        ...state,
        title: action.payload
      }
    },
    loadChange: (state, action) => {
      return {
        ...state,
        load: action.payload
      } 
    }
  }
})

export const { back, items, itemView, updateTitle, loadChange } = viewSlice.actions

export default viewSlice.reducer